function queryStringToJsonObj(qs) {
    qs = qs || location.search.slice(1);

    var pairs = qs.split('&');
    var result = {};
    pairs.forEach(function (p) {
        var pair = p.split('=');
        var key = pair[0];
        var value = decodeURIComponent(pair[1] || '');

        if (result[key]) {
            if (Object.prototype.toString.call(result[key]) === '[object Array]') {
                result[key].push(value);
            } else {
                result[key] = [result[key], value];
            }
        } else {
            result[key] = value;
        }
    });

    return JSON.parse(JSON.stringify(result));
}

function getCurrentUrlObj() {
    var n = window.location.hash.lastIndexOf('?');
    var urlObj = {};
    if (n !== -1) {
        urlObj.url = window.location.hash.substr(0, n);
        var locqs = window.location.hash.substr(n + 1);
        urlObj.qsObj = queryStringToJsonObj(locqs);
    } else {
        urlObj.url = window.location.hash;
        urlObj.qsObj = {}
    }
    return urlObj;
}

function getSelectedKeys() {
    var selection = getSelectedData();
    if (selection.length === 0) return [];
    return selection.map(x => x.ID);
}

function getSelectedData() {
    var grid = $("#datagridDx1Container").dxDataGrid("instance");
    if (grid === undefined) return [];
    return grid.getSelectedRowsData();
}

function showLoadPanel() {
    window.loadPanel.show();
}

function hideLoadPanel() {
    window.loadPanel.hide();
}

function compressBreadcrumb() {
    //code for compacting breadcrumb if it gets too large to fit on same line
    try {
        if ($(".breadcrumb-content")[0].scrollHeight > 80)
            $(".breadcrumb-content .breadcrumb-button").css("min-width", "unset");

        if ($(".appBar")[0].scrollHeight > 80)
            $(".appBar .appbar-button").css("min-width", "unset");

    } catch (e) { }
}

function showMessage(message, title) {
    DevExpress.ui.dialog.alert(message, title);
    window.loadPanel.hide();
}

function showToast(message, type, duration) {
    var maxWidth = 150;
    if (message.length > 25) {
        maxWidth = 300;
    }
    if (message > 100) {
        maxWidth = 600;
    }
    DevExpress.ui.notify({ message: message, position: "top center", maxWidth: maxWidth }, type, duration);
}

function getWebAppTranslation(key, placeholder) {
    if (!placeholder) placeholder = "!" + key;
    if (!window.appConfig) return placeholder;

    var label = window.appConfig.translations.find(x => x.id === key) ?
        window.appConfig.translations.find(x => x.id === key).label : placeholder;

    return label;
}

function findFormField(items, name) {
    var obj = "";
    if (items[0].items) {
        for (var i = 0; i < items.length; i++) {
            var tmp = items[i].items.find(x => x.dataField === name);
            if (tmp) {
                obj = tmp;
                break;
            }
        }
    } else {
        obj = items.find(x => x.dataField === name);
    }
    return obj;
}

function selectOnlyRow() {
    var grid = sharedFunctions.getGrid();
    var numberOfRows = grid.getVisibleRows();
    if (numberOfRows.length === 1) {
        grid.selectRowsByIndexes([0]);
    }

    setTimeout(compressBreadcrumb, 100);
}

//framework hooks
window.hasCustomStore = function (url, module) {

    if (window.currentPage !== "details") return false;

    module = module.toLowerCase();
    url = url.toLowerCase();

    switch (module) {
        ////template
        //case (""):
        //    if (url.endsWith("?table=QQQQ")) return true;
        //    break;

        default:
            //nothing yet
            break;
    }
    return false;
}


window.customStore = function (url, module, parentQs, customQs, params) {
    url = url.toLowerCase();
    module = module.toLowerCase();
    var urlSuffix = "&listModule=" + module + parentQs + customQs;
    var data = $("#details-form-container").dxForm("instance").option('formData');
    var table = url.split("?table=").slice(-1)[0];

    switch (table) {
        case "dbcolumn":
            var module = data["WebModuleID"];
            return $.getJSON("../api/project/getdbcolumnsformodule?module=" + module + urlSuffix, params);
    }

    console.log("Error in window.customStore: unable to resolve '" + url + "'");
    return false;
}

window.customFormFieldChange = function (formField, event) {
    var form = $("#details-form-container").dxForm("instance");
    var items = $("#details-form-container").dxForm("instance").option('items');
    var data = $("#details-form-container").dxForm("instance").option('formData');

    switch (event.dataField) {
        case "SpeciesID":
            //if (data.SpeciesID !== null) {

            //    $.ajax({
            //        url: '../api/project/getsamplefishpresentation?species=' + data.SpeciesID + '&fatecategory=' + data.FateCategoryID,
            //        type: 'GET',
            //        contentType: 'application/json',
            //        dataType: "json"
            //    }).done(function (result) {
            //        if (result.Error) {
            //            showMessage(result.Error, getWebAppTranslation("fe13"));
            //            return;
            //        } else {
            //            if (result.Result !== null) {
            //                form.updateData("FishPresentationID", result.Result);
            //            }
            //        }

            //    }).fail(function (xhr, textStatus, errorThrown) {
            //        showMessage(xhr.responseText, getWebAppTranslation("fe13"));
            //    }).always(function () {
            //        hideLoadPanel();
            //    });

            //    if (form.getEditor("LengthMeasurementTypeID") !== undefined) {
            //        $.ajax({
            //            url: '../api/project/getlengthmeasurementtypeid?speciesid=' + event.value,
            //            type: 'GET',
            //            contentType: 'application/json',
            //            dataType: "json"
            //        }).done(function (result) {
            //            if (result.Error) {
            //                showMessage(result.Error, getWebAppTranslation("fe13"));
            //                return;
            //            } else {
            //                if (result.Result !== null) {
            //                    form.updateData("LengthMeasurementTypeID", result.Result);
            //                }
            //            }

            //        }).fail(function (xhr, textStatus, errorThrown) {
            //            showMessage(xhr.responseText, getWebAppTranslation("fe13"));
            //        }).always(function () {
            //            hideLoadPanel();
            //        });
            //    }
            //}
            break;

        default:
            //console.log("Error in window.customFormFieldChange: unable to resolve '" + event.dataField + "'");
            break;
    }

}


window.handleCustomValidation = function (detailsComponent, errorObj) {

}


window.listPageRendered = function (module) {
    //voor eerste keer inladen
    selectOnlyRow();

    var grid = sharedFunctions.getGrid();

    // telkens de grid z'n content aanpast (vb door een search)
    grid.on({
        "contentReady": selectOnlyRow,
    });

    //if SelectedId is added to list of parameters, select row with provided ID
    var parameters = window.location.href.split('?')[1].split('&').map(x => x.split('='));
    var selectedIdParam = parameters.filter(x => x[0] === "selectedID");
    if (selectedIdParam != null && selectedIdParam.length > 0) {
        var selectedId = selectedIdParam[0][1]; //first result, value of keyvaluepair
        var selectionIndex = grid.getVisibleRows().map(x => x.key).indexOf(selectedId);
        if (selectionIndex > -1) grid.selectRowsByIndexes([selectionIndex]);
    }

    switch (module) {

        default:
            $("#btn-create").show();
            $("#btn-edit").show();
            $("#btn-delete").show();
            break;
    }
}

window.detailsPageRendered = function (module) {
    setTimeout(compressBreadcrumb, 100);
}

//event handlers 

window.duplicateRecords = function () {
    var keys = getSelectedKeys();
    if (keys.length > 0) {
        $.ajax({
            url: '../api/admin/duplicaterecords?currentModule=' + currentModule,
            type: 'POST',
            data: JSON.stringify(keys),
            contentType: 'application/json',
            dataType: "json"
        }).done(function (result) {
            if (result.Error) {
                showMessage(result.Error, getWebAppTranslation("fe13"));
                return;
            } else {
                window.IlvoGrid.loadAndRenderData();
            }
        }).fail(function (xhr, textStatus, errorThrown) {
            showMessage(xhr.responseText, getWebAppTranslation("fe13"));
        }).always(function () {
            hideLoadPanel();
        });
    }
}

window.duplicateRecordsInto = function (navProp, targetIds) {
    var keys = getSelectedKeys();
    var sourceIds = JSON.stringify(keys);
    var navPr = navProp;
    var targets = JSON.stringify(targetIds);
    if (keys.length > 0) {
        $.ajax({
            url: '../api/admin/duplicaterecordsinto?currentModule=' + currentModule,
            type: 'POST',
            data: JSON.stringify({
                sourceIds: keys,
                navProp: navProp,
                targetIds: targetIds
            }),
            contentType: 'application/json',
            dataType: "json"
        }).done(function (result) {
            if (result.Error) {
                showMessage(result.Error, getWebAppTranslation("fe13"));
                return;
            } else {
                window.IlvoGrid.loadAndRenderData();
            }
        }).fail(function (xhr, textStatus, errorThrown) {
            showMessage(xhr.responseText, getWebAppTranslation("fe13"));
        }).always(function () {
            hideLoadPanel();
        });
    }
}

function getDataSource(url) {
    return new DevExpress.data.DataSource({
        store: new DevExpress.data.CustomStore({
            loadMode: "raw",
            load: function () {
                var d = $.Deferred();
                $.ajax({
                    url: url,
                    success: function (result) {
                        d.resolve(result.Result);
                    }
                });
                return d.promise();
            }
        })
    });
}

window.addEventListener("customAction-Toggle-Caching", function () {
    $.ajax({
        url: '../api/project/toggleCaching',
        type: 'POST',
        contentType: 'application/json',
        dataType: "json"
    }).done(function (statusResult) {
        $(".customaction[eventstring=Toggle-Caching]").removeClass("secondary");
        if (statusResult.Result === true) {
            $(".customaction[eventstring=Toggle-Caching]").removeClass("red").addClass("green");
            $(".customaction[eventstring=Toggle-Caching] span").text("Caching: ON");
        }
        else {
            $(".customaction[eventstring=Toggle-Caching]").removeClass("green").addClass("red");
            $(".customaction[eventstring=Toggle-Caching] span").text("Caching: OFF");
        }
    });
});


window.addEventListener("customAction-Invalidate-Cache", function () {
    $.ajax({
        url: '../api/project/invalidateCache',
        type: 'POST',
        contentType: 'application/json',
        dataType: "json"
    }).done(function (statusResult) {
        window.IlvoGrid.loadAndRenderData();
    });
});


window.addEventListener("customAction-PropertyConfig", function () {
    var keys = getSelectedKeys();
    if (keys.length === 1) {
        var mapUrl = '../project/propconfig.html?dbtableid=' + keys[0];
        Object.assign(document.createElement('a'), { target: '_blank', href: mapUrl }).click();
    } else {
        showMessage('Bulk operations are not supported.', 'Error');
    }
});

window.addEventListener("customAction-ApproveUser", function () {

    var formData = {
        SelectedIds: getSelectedKeys(),
        DenyReason: null,
    }

    $.ajax({
        url: '../api/project/approveuser',
        type: 'POST',
        data: JSON.stringify(formData),
        contentType: 'application/json',
        dataType: "json"
    }).done(function (result) {
        if (result.Error) {
            showMessage(result.Error, 'Error');
        } else {
            window.IlvoGrid.loadAndRenderData();
            DevExpress.ui.notify({ message: "User.", position: "top center", maxWidth: 380 }, "success", 5000);
        }
    });
});

window.addEventListener("customAction-DenyUser", function () {

    var formData = {
        SelectedIds: getSelectedKeys(),
        DenyReason: null,
    }

    function performAction() {
        var form = $("#DenyUser-form").dxForm("instance");
        var formValidation = form.validate();

        if (formValidation.isValid) {
            $.ajax({
                url: '../api/project/denyuser',
                type: 'POST',
                data: JSON.stringify(form.option('formData')),
                contentType: 'application/json',
                dataType: "json"
            }).done(function (result) {
                if (result.Error) {
                    $("#DenyUser-summary").dxValidationSummary('instance').option("items", [{ text: result.Error }]);
                } else {
                    formData.DenyReason = null;

                    form.repaint();
                    window.IlvoGrid.loadAndRenderData();

                    // show toast message
                    DevExpress.ui.notify({ message: "User denied.", position: "top center", maxWidth: 360 }, "success", 5000);
                }
            });
        }
    }

    if ($('#popup-container').length === 0) {
        $('#appContent').append('<div id="popup-container"></div>');
    }

    const popupContentTemplate = function () {
        return $('<div>').append($(`<div id="DenyUser-form"></div><div id="DenyUser-summary"></div>`));
    };
    const popup = $('#popup-container').dxPopup({
        contentTemplate: popupContentTemplate,
        width: 500,
        height: 470,
        container: 'document',
        showTitle: true,
        title: 'Deny user access',
        visible: false,
        dragEnabled: true,
        closeOnOutsideClick: true, //non-default!
        showCloseButton: false,
        position: 'center',
        shading: true,
        shadingColor: 'rgba(245, 40, 145, 0)',
        toolbarItems: [
            {
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'after',
                options: {
                    text: getWebAppTranslation("save"),
                    onClick() {
                        performAction();
                    },
                },
            },
            {
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'after',
                options: {
                    text: getWebAppTranslation("close"),
                    onClick() {
                        popup.hide();
                    },
                },
            }],
        onShown: function (e) {
            const form = $('#DenyUser-form').dxForm({
                labelMode: 'floating',
                validationGroup: 'ss-group',
                formData: formData,
                items: [
                    {
                        dataField: 'DenyReason',
                        editorType: 'dxTextBox',
                        isRequired: true
                    },
                ],
                readOnly: false,
                showColonAfterLabel: false,
                labelLocation: 'left'
            }).dxForm('instance');

            $("#DenyUser-summary").dxValidationSummary({ validationGroup: "ss-group" }).dxValidationSummary("instance");
            form.repaint();
        }
    }).dxPopup('instance');

    popup.show();
});

window.addEventListener("customAction-LayerFileUpload", function () {

    console.log("uploading");

    var formData = {
        RecordID: queryStringToJsonObj(window.location.hash.substr(window.location.hash.lastIndexOf('?') + 1))["bc:Layer"],
        //FileSourceType: 0,
        //FileTypeID: '7258A5D9-8295-4BC5-8A77-A839A10AE0A1',
        //Url: null,
        Files: [],
        //Description: null,
    }

    if (!formData.RecordID) {
        console.log("No recordid found, look into grid for ID");
        var rows = $("#datagridDx1Container").dxDataGrid("instance").getSelectedRowsData();
        if (rows && rows.length>0) {
            formData.RecordID = rows[0].ID;
        }
    }
    formData.ParentID = formData.RecordID;

    function uploadFiles() {
        var form = $("#LayerFileUpload-form").dxForm("instance");
        var formValidation = form.validate();

        if (formValidation.isValid) {

            var fdata = new FormData(); //required; enables FromForm attribute usage
            //IMPORTANT: FormData values cannot contain null! (will cause error 415)
            //NOTE: FormData does not require/need all model properties
            if (formData.ParentID != null) fdata.append("RecordID", formData.ParentID);
            //if (formData.FileTypeID != null) fdata.append("FileTypeID", formData.FileTypeID);
            //if (formData.Description != null) fdata.append("Description", formData.Description);
            //if (formData.Url != null) fdata.append("Url", formData.Url);
            for (var i = 0; i != formData.Files.length; i++) {
                fdata.append("Files", formData.Files[i]);
            }

            $.ajax({
                url: '../api/project/layerfileupload',
                type: 'POST',
                data: fdata, //FormData class instance instead of modal form object
                processData: false,
                contentType: false,
            }).done(function (result) {
                if (result.Error) {
                    $("#LayerFileUpload-summary").dxValidationSummary('instance').option("items", [{ text: result.Error }]);
                } else {
                    window.IlvoGrid.loadAndRenderData();
                    popup.hide();
                }
            });
        }
    }

    if ($('#popup-container').length === 0) {
        $('#appContent').append('<div id="popup-container"></div>');
    }

    const popupContentTemplate = function () {
        return $('<div>').append($(`<div id="LayerFileUpload-form"></div><div id="LayerFileUpload-summary"></div>`));
    };
    const popup = $('#popup-container').dxPopup({
        contentTemplate: popupContentTemplate,
        width: 500,
        height: 400,
        container: 'document',
        showTitle: true,
        title: 'File Upload',
        visible: false,
        dragEnabled: true,
        closeOnOutsideClick: false,
        showCloseButton: false,
        position: 'center',
        shading: true,
        shadingColor: 'rgba(245, 40, 145, 0)',
        toolbarItems: [
            {
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'after',
                options: {
                    text: "Upload",
                    onClick() {
                        uploadFiles();
                    },
                },
            },
            {
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'after',
                options: {
                    text: getWebAppTranslation("close"),
                    onClick() {
                        popup.hide();
                    },
                },
            }],
        onShown: function (e) {
            const form = $('#LayerFileUpload-form').dxForm({
                labelMode: 'floating',
                validationGroup: 'ss-group',
                formData: formData,
                items: [
                    {
                        dataField: 'Files',
                        label: { text: 'Path' },
                        editorType: 'dxFileUploader',
                        editorOptions: {
                            multiple: true,
                            accept: '*',
                            value: [],
                            uploadMode: 'useForm',
                            uploadUrl: null,
                        },
                    },
                ],
                readOnly: false,
                showColonAfterLabel: false,
                labelLocation: 'left'
            }).dxForm('instance');

            $("#LayerFileUpload-summary").dxValidationSummary({ validationGroup: "ss-group" }).dxValidationSummary("instance");
            form.repaint();
        }
    }).dxPopup('instance');

    popup.show();

});

window.addEventListener("customAction-LayerBulkFileUpload", function () {

    console.log("bulk file uploading");

    var formData = {
        Files: []
    }

    function uploadFilesBulk() {
        var form = $("#LayerFileBulkUpload-form").dxForm("instance");
        var formValidation = form.validate();

        if (formValidation.isValid) {

            var fdata = new FormData(); //required; enables FromForm attribute usage
            for (var i = 0; i != formData.Files.length; i++) {
                fdata.append("Files", formData.Files[i]);
            }

            $.ajax({
                url: '../api/project/layerbulkfileupload',
                type: 'POST',
                data: fdata, //FormData class instance instead of modal form object
                processData: false,
                contentType: false,
            }).done(function (result) {
                if (result.Error) {
                    $("#LayerBulkFileUpload-summary").dxValidationSummary('instance').option("items", [{ text: result.Error }]);
                } else {
                    window.IlvoGrid.loadAndRenderData();
                    popup.hide();
                }
            });
        }
    }

    if ($('#popup-container').length === 0) {
        $('#appContent').append('<div id="popup-container"></div>');
    }

    const popupContentTemplate = function () {
        return $('<div>').append($(`<div id="LayerFileBulkUpload-form"></div><div id="LayerBulkFileUpload-summary"></div>`));
    };
    const popup = $('#popup-container').dxPopup({
        contentTemplate: popupContentTemplate,
        width: 500,
        height: 400,
        container: 'document',
        showTitle: true,
        title: 'Bulk File Upload',
        visible: false,
        dragEnabled: true,
        closeOnOutsideClick: false,
        showCloseButton: false,
        position: 'center',
        shading: true,
        shadingColor: 'rgba(245, 40, 145, 0)',
        toolbarItems: [
            {
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'after',
                options: {
                    text: "Upload",
                    onClick() {
                        uploadFilesBulk();
                    },
                },
            },
            {
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'after',
                options: {
                    text: getWebAppTranslation("close"),
                    onClick() {
                        popup.hide();
                    },
                },
            }],
        onShown: function (e) {
            const form = $('#LayerFileBulkUpload-form').dxForm({
                labelMode: 'floating',
                validationGroup: 'ss-group',
                formData: formData,
                items: [
                    {
                        dataField: 'Files',
                        label: { text: 'Path' },
                        editorType: 'dxFileUploader',
                        editorOptions: {
                            multiple: true,
                            accept: '.geojson',
                            value: [],
                            uploadMode: 'useForm',
                            uploadUrl: null,
                            allowedFileExtensions: ['.geojson'],
                            labelText: 'of sleep bestanden hier',
                            selectButtonText: 'Selecteer bestanden',
                            inputAttr: { 'aria-label': 'Selecteer bestanden' }
                        },
                    },
                ],
                readOnly: false,
                showColonAfterLabel: false,
                labelLocation: 'left'
            }).dxForm('instance');

            $("#LayerBulkFileUpload-summary").dxValidationSummary({ validationGroup: "ss-group" }).dxValidationSummary("instance");
            form.repaint();
        }
    }).dxPopup('instance');

    popup.show();

});
function doBulkLink(tableName, parentName, childName, state) {
    var keys = getSelectedKeys();
    if (keys.length == 0) return;

    var form = new FormData();
    form.append("LinkTableName", tableName);
    form.append("ParentPropertyName", parentName);
    form.append("ChildPropertyName", childName);
    form.append("IsChecked", state);
    for (var i = 0; i != keys.length; i++) {
        form.append("SelectedIDs", keys[i]);
    }

    $.ajax({
        url: '../api/project/BulkLink',
        type: 'POST',
        data: form,
        processData: false,
        contentType: false,
    }).done(function (result) {
        if (result.Error) {
            showMessage(result.Error, getWebAppTranslation("fe13"));
            return;
        } else {
            window.IlvoGrid.loadAndRenderData();
        }
    }).fail(function (xhr, textStatus, errorThrown) {
        showMessage(xhr.responseText, getWebAppTranslation("fe13"));
    }).always(function () {
        hideLoadPanel();
    });

}

window.addEventListener("customAction-PolicyFileUpload", function () {

    console.log("Policy file uploading");

    const policyTypes = [{
        ID: 'GESLOTENGEBIEDEN',
        Name: 'Gesloten gebiedenana',
    }, {
        ID: 'VISSERIJREGELGEVING',
        Name: 'Visserijregelgeving',
    }, {
        ID: 'TAM',
        Name: 'Tijdelijk aanvullende maatregel',
    }, {
        ID: 'QUOTA_POLARIS',
        Name: 'Quota & benutting Polaris',
    }, {
        ID: 'QUOTA_SDV',
        Name: 'Quota & benutting stand der vangsten',
    }]

    var formData = {
        Files: [],
        policyType:'GESLOTENGEBIEDEN',
        dryRun: false
    }

    function uploadPolicyFile() {
        var form = $("#PolicyFileUpload-form").dxForm("instance");
        var formValidation = form.validate();

        if (formValidation.isValid) {

            var fdata = new FormData(); //required; enables FromForm attribute usage
            for (var i = 0; i != formData.Files.length; i++) {
                fdata.append("Files", formData.Files[i]);
            }
            fdata.append("PolicyType", formData.PolicyType);
            fdata.append("DryRun", formData.DryRun);

            $.ajax({
                url: '../api/project/policyfileupload',
                type: 'POST',
                data: fdata, //FormData class instance instead of modal form object
                processData: false,
                contentType: false,
            }).done(function (result) {
                if (result.Error) {
                    $("#PolicyFileUpload-summary").dxValidationSummary('instance').option("items", [{ text: result.Error }]);
                } else {
                    window.IlvoGrid.loadAndRenderData();
                    popup.hide();
                }
            });
        }
    }

    if ($('#popup-container').length === 0) {
        $('#appContent').append('<div id="popup-container"></div>');
    }

    const popupContentTemplate = function () {
        return $('<div>').append($(`<div id="PolicyFileUpload-form"></div><div id="PolicyFileUpload-summary"></div>`));
    };
    const popup = $('#popup-container').dxPopup({
        contentTemplate: popupContentTemplate,
        width: 500,
        height: 400,
        container: 'document',
        showTitle: true,
        title: 'Policy File Upload',
        visible: false,
        dragEnabled: true,
        closeOnOutsideClick: false,
        showCloseButton: false,
        position: 'center',
        shading: true,
        shadingColor: 'rgba(245, 40, 145, 0)',
        toolbarItems: [
            {
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'after',
                options: {
                    text: "Upload",
                    onClick() {
                        uploadPolicyFile();
                    },
                },
            },
            {
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'after',
                options: {
                    text: getWebAppTranslation("close"),
                    onClick() {
                        popup.hide();
                    },
                },
            }],
        onShown: function (e) {
            const form = $('#PolicyFileUpload-form').dxForm({
                
                validationGroup: 'ss-group',
                formData: formData,
                items: [{
                        dataField: 'PolicyType',
                        editorType: 'dxSelectBox',
                        editorOptions: {
                        // items: positions,
                         dataSource: policyTypes,
                        valueExpr: "ID",
                        displayExpr: "Name",
                        searchEnabled: true,
                        value: '',
                        },
                        validationRules: [{
                            type: 'required',
                            message: getWebAppTranslation("policyfile-upload-type-required") ,
                        }],
                        dataSource: policyTypes,
                        valueExpr: "ID",
                        displayExpr: "Name",
                        labelMode: 'floating',
                        //label: {  location:'top' }, 
                        // label: {
                        // template: labelTemplate('info'),
                        // },
                    },
                    {
                        dataField: 'Files',
                        labelMode: 'floating',
                        label: { text: 'Bestand' },
                        editorType: 'dxFileUploader',
                        editorOptions: {
                            multiple: false,
                            accept: '.xlsx,.xls',
                            value: [],
                            uploadMode: 'useForm',
                            uploadUrl: null,
                            allowedFileExtensions: ['.xlsx', '.xls']
                        },
                    }, 
                    {  
                        dataField: 'DryRun',  
                        editorType: 'dxCheckBox',  
                        label: { text: getWebAppTranslation("policyfile-upload-dryrun"), location:'top' }, 
                        editorOptions: {  
                            value: false
                         }
                    }
                ],
                readOnly: false,
                showColonAfterLabel: false,
                labelLocation: 'left'
            }).dxForm('instance');

            $("#PolicyFileUpload-summary").dxValidationSummary({ validationGroup: "ss-group" }).dxValidationSummary("instance");
            form.repaint();
        }
    }).dxPopup('instance');

    popup.show();

});

window.addEventListener("customAction-LayerProfile-BL0", function () { doBulkLink('LayerProfile', 'LayerID', 'ProfileID', false); });
window.addEventListener("customAction-LayerProfile-BL1", function () { doBulkLink('LayerProfile', 'LayerID', 'ProfileID', true); });
window.addEventListener("customAction-ProfileLayer-BL0", function () { doBulkLink('LayerProfile', 'ProfileID', 'LayerID', false); });
window.addEventListener("customAction-ProfileLayer-BL1", function () { doBulkLink('LayerProfile', 'ProfileID', 'LayerID', true); });

window.addEventListener("customAction-UserProfile-BL0", function () { doBulkLink('UserProfile', 'UserID', 'ProfileID', false); });
window.addEventListener("customAction-UserProfile-BL1", function () { doBulkLink('UserProfile', 'UserID', 'ProfileID', true); });
window.addEventListener("customAction-ProfileUser-BL0", function () { doBulkLink('UserProfile', 'ProfileID', 'UserID', false); });
window.addEventListener("customAction-ProfileUser-BL1", function () { doBulkLink('UserProfile', 'ProfileID', 'UserID', true); });


window.addEventListener("customAction-UpdateStockLayers", function () {

    var currentYear = new Date().getFullYear();

    var formData = {
        YearEarliest: currentYear - 1,
        YearLatest: currentYear
    }

    function updateStocks() {
        var form = $("#UpdateStockLayers-form").dxForm("instance");
        var formValidation = form.validate();

        if (formValidation.isValid) {

            var fdata = new FormData(); //required; enables FromForm attribute usage
            //IMPORTANT: FormData values cannot contain null! (will cause error 415)
            //NOTE: FormData does not require/need all model properties
            if (formData.YearEarliest != null) fdata.append("YearEarliest", formData.YearEarliest);
            if (formData.YearLatest != null) fdata.append("YearLatest", formData.YearLatest);

            $.ajax({
                url: '../api/project/updatestocks',
                type: 'POST',
                data: fdata, //FormData class instance instead of modal form object
                processData: false,
                contentType: false,
            }).done(function (result) {
                popup.hide();
                if (result.Error) {
                    showMessage(result.Error, 'Error');
                } else {
                    window.IlvoGrid.loadAndRenderData();
                    DevExpress.ui.notify({ message: "Stock status layers updated.", position: "top center", maxWidth: 380 }, "success", 5000);
                }
            });
        }
    }

    if ($('#popup-container').length === 0) {
        $('#appContent').append('<div id="popup-container"></div>');
    }

    const popupContentTemplate = function () {
        return $('<div>').append($(`<div id="UpdateStockLayers-form"></div><div id="UpdateStockLayers-summary"></div>`));
    };
    const popup = $('#popup-container').dxPopup({
        contentTemplate: popupContentTemplate,
        width: 500,
        height: 400,
        container: 'document',
        showTitle: true,
        title: 'Update ICES Stock Layers',
        visible: false,
        dragEnabled: true,
        closeOnOutsideClick: false,
        showCloseButton: false,
        position: 'center',
        shading: true,
        shadingColor: 'rgba(245, 40, 145, 0)',
        toolbarItems: [
            {
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'after',
                options: {
                    text: "Update",
                    onClick() {
                        updateStocks();
                    },
                },
            },
            {
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'after',
                options: {
                    text: getWebAppTranslation("close"),
                    onClick() {
                        popup.hide();
                    },
                },
            }],
        onShown: function (e) {
            const form = $('#UpdateStockLayers-form').dxForm({
                labelMode: 'floating',
                validationGroup: 'ss-group',
                formData: formData,
                items: [
                    {
                        dataField: 'YearEarliest',
                        label: { text: 'Earliest Year' },
                        editorType: "dxNumberBox",
                        editorOptions: {
                            showSpinButtons: true,
                            showClearButton: false,
                            format: "#",
                            min: 2010,
                            max: currentYear,
                            value: currentYear - 1
                        }
                    },
                    {
                        dataField: 'YearLatest',
                        label: { text: 'Latest Year' },
                        editorType: "dxNumberBox",
                        editorOptions: {
                            showSpinButtons: true,
                            showClearButton: false,
                            format: "#",
                            min: 2010,
                            max: currentYear,
                            value: currentYear
                        }
                    }
                ],
                readOnly: false,
                showColonAfterLabel: false,
                labelLocation: 'left'
            }).dxForm('instance');

            $("#UpdateStockLayers-summary").dxValidationSummary({ validationGroup: "ss-group" }).dxValidationSummary("instance");
            form.repaint();

            $("#UpdateStockLayers-form")
                .append('<div style="color:orange;border:1px solid orange;background-color:rgba(255,206,105,0.3);padding:1em; margin-top:30px;">' +
                'Note: This operation may take well over an hour to complete!<br />A mail will be sent when the process has concluded.</div > ');
        }
    }).dxPopup('instance');

    popup.show();

});